module.exports = __webpack_public_path__ + "img/SCG.a9163c58.svg";